import Modal from './Modal';

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger', // 'danger' | 'warning' | 'primary'
  isLoading = false,
}) {
  const variantConfig = {
    danger: { btnClass: 'btn-danger', color: '#ef4444' },
    warning: { btnClass: 'btn-amber', color: '#f59e0b' },
    primary: { btnClass: 'btn-primary', color: '#6366f1' },
  };
  const v = variantConfig[variant] || variantConfig.danger;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-center">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
          style={{ background: `${v.color}18`, border: `1px solid ${v.color}40` }}
        >
          <span className="text-2xl">⚠️</span>
        </div>
        <h3 className="heading text-xl font-semibold text-white mb-2">{title}</h3>
        {message && <p className="text-white/60 text-sm mb-6 leading-relaxed">{message}</p>}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="btn-secondary flex-1"
            disabled={isLoading}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`${v.btnClass} flex-1`}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.3" />
                  <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                </svg>
                Processing...
              </span>
            ) : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
